var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 492.308 492.308",
    style: {
      enableBackground: "new 0 0 492.308 492.308"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F59",
    d: "M236.308 213.652H256v191.124h-19.692zM236.308 159.872H256v24.507h-19.692z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M486.823 422.837 283.073 23.75C275.486 8.885 261.679 0 246.159 0c-15.529 0-29.337 8.885-36.923 23.75L5.477 422.837c-7.894 15.471-7.192 34.24 1.827 48.981 7.856 12.827 20.981 20.49 35.096 20.49h407.51c14.125 0 27.24-7.663 35.096-20.49 9.019-14.741 9.721-33.51 1.817-48.981zm-18.615 38.701c-4.308 7.038-10.981 11.077-18.298 11.077H42.4c-7.317 0-13.99-4.038-18.298-11.077-5.471-8.942-5.885-20.337-1.086-29.74l203.76-399.087c4.163-8.154 11.404-13.019 19.385-13.019 7.971 0 15.212 4.865 19.375 13.019l203.75 399.087c4.806 9.404 4.393 20.798-1.078 29.74z",
    fill: "#FF5F59"
  })));
};
export { SvgWarning as ReactComponent };
export default __webpack_public_path__ + "images/warning.svg";